import { Component, Input } from '@angular/core';
import { CommonModule } from 'src/common/common.module';
import { Link } from 'src/common/models';


@Component({
  selector: 'app-nav-list',
  imports: [CommonModule],
  templateUrl: './nav-list.component.html',
  styleUrl: './nav-list.component.css'
})
export class NavListComponent {
  @Input() items: Link[] = [];

}
